import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import NotFound from "@Pages/NotFound";
import loadData from "./data";
import { useEffect, memo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import { fetchVideoPageDataIfNeeded } from "./data/videoPageReducer";
import { useRouteMatch } from "react-router-dom";
import wrapperHOC from "@Utils/wrapperHOC";

const VideoPage = loadable(() => import("./VideoPage"), {
  fallback: <FullPageLoader />,
});

const VideoPageEntry = (props: any) => {
  const dispatch = useDispatch();
  const match = useRouteMatch<{ id: string; videoId: string }>();

  const { readyStatus, loadedCanonicalName, dataSource } = useSelector(
    ({ videoPageData }: AppState) => ({
      readyStatus: videoPageData.readyStatus,
      loadedCanonicalName: videoPageData.data?.canonical_name,
      dataSource: videoPageData.dataSource,
    }),
    shallowEqual,
  );

  const propertyId = match?.params?.id;

  useEffect(() => {
    if (__CLIENT__) {
      // Fetch if data isn't loaded, failed, is for a different property, or was pre-seeded from gallery
      if (
        readyStatus === "invalid" ||
        readyStatus === "failure" ||
        loadedCanonicalName !== propertyId ||
        dataSource === "gallery"
      ) {
        dispatch(
          fetchVideoPageDataIfNeeded({
            ...props,
            match,
          }),
        );
      }
    }
  }, [propertyId, readyStatus, loadedCanonicalName, dataSource]);

  if (readyStatus === "failure") {
    return <NotFound isStatus500 />;
  }

  if (readyStatus === "request" || readyStatus === "invalid") {
    if (__CLIENT__) {
      return <FullPageLoader />;
    }
    return null;
  }

  return <VideoPage />;
};

export default wrapperHOC(memo(VideoPageEntry), {
  componentName: "VideoPage",
  showForChina: true,
});
export { loadData };
